import React, { useEffect, useState } from "react";
import { ArrowRight, Search, ChevronUp, ChevronDown, ChevronsUpDown, Eye, EyeOff, Download, X, EllipsisVerticalIcon, Info } from "lucide-react";
import TagCostInfoModal from "../../components/common/TagCostInfoModal";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import TextInput from "../../Commponent/TextInput";
import FastagPurchase from "../../Commponent/FastagPurchase";
import ReverseInventoryModal from "../../Commponent/ReverseInventoryModal";
import { getVehicleClassData } from "../../Utils/helper";
import { vehicleClasses } from '../../Utils/Constants';
import CommonTable from "../../Common/CommonTable";
import { useDispatch, useSelector } from "react-redux";
import { ACTIONS } from "../../redux/actions";
import { ErrorToast, SuccessToast } from "../../Utils/toast";
import moment from "moment";
import CommonTableModal from "../../Commponent/CommonTableModal";
import { AgentDetails } from "../../Commponent/AddAgent";
import { getRole } from "../../Utils/auth";
import CustomSelectInput from "../../Commponent/SelectInput";
import { API } from "../../Common/Api";

//distributor Inventory
const InventoryPage = () => {
  const role = getRole();
  const dispatch = useDispatch();
  const GetInventoryDistributor = useSelector((state) => state.GetInventoryDistributor.GetInventoryDistributorData);
  const GetDistributorSummary = useSelector((state) => state.GetDistributorSummary.GetDistributorSummaryData);
  const GetAgentsNames = useSelector((state) => state.GetAgentsNames.GetAgentsNamesData);
  const refreshCount = useSelector((state) => state.Refresh?.refreshCount);
  const [show, setShow] = useState(false);
  const [showReverse, setShowReverse] = useState(false);
  const [serialNumber, setSerialNumber] = useState("");
  const [selectedAgent, setSelectedAgent] = useState("");
  // Date-wise sort on the "FASTag Activation Date" column, on demand.
  const [activationDateSortEnabled, setActivationDateSortEnabled] = useState(false);
  const [activationDateSortOrder, setActivationDateSortOrder] = useState("desc"); // 'desc' = newest first, 'asc' = oldest first
  const [date, setDate] = useState(new Date());
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [visibleRows, setVisibleRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [inventoryData, setInventoryData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkInventoryDistributor, setCheckInventoryDistributor] = useState(false);
  const [checkDistributorSummary, setCheckDistributorSummary] = useState(false);
  const [assigningAgent, setAssigningAgent] = useState('');
  const [agentModalOpen, setAgentModalOpen] = useState(false);
  const [mobile, setMobile] = useState('');
  const [modalItem, setModalItem] = useState('');
  const [selectedAgentClick, setSelectedAgentClick] = useState(false);
  const [selectedTagRefId, setSelectedTagRefId] = useState(null);
  const [selectedTagActivated, setSelectedTagActivated] = useState(false);
  const [modalInitialTab, setModalInitialTab] = useState('cost');
  const [activeTab, setActiveTab] = useState('available');
  const [agentDataNames, setAgentDataNames] = useState([]);
  const [checkAgentsName, setCheckAgentsName] = useState(false);
  const [activationFilter, setActivationFilter] = useState("");
  const [dealerActivationFilter, setDealerActivationFilter] = useState(""); // FASTag Activation status (Dealer Inventory tab)
  // Agent Inventory cascade: this distributor's dealers, the selected dealer,
  // and that dealer's agents.
  const [invDealers, setInvDealers] = useState([]);
  const [selectedInvDealer, setSelectedInvDealer] = useState("");
  const [invDealerAgents, setInvDealerAgents] = useState(null);
  // Dealer Inventory tab: filter by a specific dealer.
  const [dealerTabDealer, setDealerTabDealer] = useState("");
  const [summaryStats, setSummaryStats] = useState([
    { label: "Total FASTag", value: 0, percent: 0, color: "#16a34a" },
    { label: "Dealer Assigned", value: 0, percent: 0, color: "#7c3aed" },
    { label: "Agent Assigned", value: 0, percent: 0, color: "#dc2626" },
    { label: "User Assigned", value: 0, percent: 0, color: "#f59e0b" },
    { label: "Available in Stock", value: 0, percent: 0, color: "#2563eb" },
  ]);


  const columns = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
  ];


  const columns1 = [
    { label: 'Serial Number', accessor: 'SerialNumber' },
    { label: 'Vehicle Class', accessor: 'VehicleClass' },
    { label: 'Status', accessor: 'Status' },
    { label: 'Purchase Date 1', accessor: 'PurchaseDate' },
    { label: 'Assigned to', accessor: 'AssignedTo' },
    { label: 'Delivery Date', accessor: 'DeliveryDate' },
    { label: 'Delivery Status', accessor: 'DeliveryStatus' },
  ];

  const data = [
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC4",
      Status: "Unassigned",
      PurchaseDate: "3 March, 2025",
      AssignedTo: "5 March, 2025",
      vehicleClass: 6,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC5",
      Status: "Unassigned",
      PurchaseDate: "30 March, 2025",
      AssignedTo: "1 March, 2025",
      vehicleClass: 5,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    },
    {
      SerialNumber: "SR35194658",
      VehicleClass: "VC6",
      Status: "Unassigned",
      PurchaseDate: "1 March, 2025",
      AssignedTo: "30 March, 2025",
      vehicleClass: 4,
      DeliveryDate: "3 March, 2025",
      DeliveryStatus: "Delivered",
    }
  ]
  // Toggles the "FASTag Activation Date" sort: off -> desc (newest first) -> asc -> desc ...
  const toggleActivationDateSort = () => {
    if (!activationDateSortEnabled) {
      setActivationDateSortEnabled(true);
      setActivationDateSortOrder("desc");
    } else {
      setActivationDateSortOrder((prev) => (prev === "desc" ? "asc" : "desc"));
    }
    setCurrentPage(1);
  };

  const ActivationDateSortIcon = () => {
    if (!activationDateSortEnabled) return <ChevronsUpDown className="w-3.5 h-3.5" />;
    return activationDateSortOrder === "desc" ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronUp className="w-3.5 h-3.5" />;
  };

  const toggleVisibility = (index, row) => {

    const isVisible = visibleRows[index];
    const newVisibility = { ...visibleRows, [index]: !isVisible };
    setVisibleRows(newVisibility);

    if (window.innerWidth >= 0) {
      setModalOpen(!isVisible);
    }

    if (!isVisible) {
      setSelectedClass(row);
      setSelectedIndex(index);
    }
  };


  const handleAgentClick = (agentName) => {
    setSelectedAgentClick(agentName);
    setAgentModalOpen(true);
  };

  const getData = () => {
    const isDealerTab = activeTab === 'dealerInventory';
    let params = {
      page: currentPage,
      limit: itemsPerPage,
      search: serialNumber,
      // Dealer tab is scoped server-side by `scope=dealer`; no status filter.
      status: isDealerTab ? '' : (activeTab === 'available' ? 'Unassigned' : 'Assigned'),
      agent: activeTab === 'agentInventory' ? selectedAgent : '',
      userActivationStatus: activeTab === 'agentInventory' ? activationFilter : '',
      // FASTag Activation status filter — the Dealer Inventory tab, and the
      // Available Inventory tab for whichever role is signed in.
      isActivated: (isDealerTab || activeTab === 'available') ? dealerActivationFilter : '',
      scope: isDealerTab ? 'dealer' : '',
      // Narrow to a specific dealer — Agent tab cascade or Dealer tab filter.
      dealer: activeTab === 'agentInventory' ? selectedInvDealer : (activeTab === 'dealerInventory' ? dealerTabDealer : ''),
      // Date-wise sort on "FASTag Activation Date" — Agent/Dealer Inventory tabs
      // (both roles), and the Available Inventory tab for a dealer (who has no
      // separate Dealer Inventory tab) — once the user turns sorting on.
      ...((isDealerTab || activeTab === 'agentInventory' || (activeTab === 'available' && role === 'dealer')) && activationDateSortEnabled && {
        activationSort: 'true',
        activationSortOrder: activationDateSortOrder,
      }),
    }
    setCheckInventoryDistributor(true)
    dispatch(ACTIONS.GetInventoryDistributorAction(params));
  }

  const getSummaryData = () => {
    setCheckDistributorSummary(true);
    dispatch(ACTIONS.GetDistributorSummaryAction());
  }

  useEffect(() => {
    setCheckAgentsName(true);
    dispatch(ACTIONS.GetAgentsNamesAction());
    // This distributor's dealers (for the Agent tab cascade).
    let myId = null;
    try { myId = JSON.parse(localStorage.getItem('UserDetail'))?._id; } catch (e) { myId = null; }
    API.GetAllDealersNames({ distributorId: myId })
      .then((res) => setInvDealers(Array.isArray(res?.data) ? res.data : []))
      .catch(() => setInvDealers([]));
  }, []);

  useEffect(() => {
    if (checkAgentsName) {
      if (GetAgentsNames?.status === 200 && GetAgentsNames?.success) {
        const uniqueAgents = Array.from(
          new Map(
            GetAgentsNames?.data?.map((agent) => [agent._id, agent])
          ).values()
        );
        setAgentDataNames(uniqueAgents);
      } else {
        ErrorToast(GetAgentsNames?.message || "Failed to fetch agents");
      }
      setCheckAgentsName(false);
    }
  }, [GetAgentsNames]);

  useEffect(() => {
    getData();
    getSummaryData();
  }, [serialNumber, currentPage, itemsPerPage, refreshCount, activeTab, selectedAgent, selectedInvDealer, dealerTabDealer, activationFilter, dealerActivationFilter, activationDateSortEnabled, activationDateSortOrder]);

  useEffect(() => {
    if (checkInventoryDistributor) {
      if (GetInventoryDistributor?.status == 200 && GetInventoryDistributor?.success) {

        setInventoryData(GetInventoryDistributor?.data.data);
      } else {
        // Enhanced error handling for different status codes
        if (GetInventoryDistributor?.status >= 400 && GetInventoryDistributor?.status < 500) {
          // 4xx errors - show backend message
          ErrorToast(GetInventoryDistributor?.message || 'Client error occurred');
        } else {
          ErrorToast(GetInventoryDistributor?.message || 'An error occurred');
        }
      }
      setCheckInventoryDistributor(false)
      // setLoading(false);
    }
  }, [GetInventoryDistributor])

  // const inventoryData = [
  //   {
  //     serialNumber: "SR35194658",
  //     status: "Assigned",
  //     vehicleClass: 4,
  //     vehicleIcon: "./../assets/bluecard.png",
  //     assignedTo: "Rohit Singh",
  //     assignedDate: "30 March, 2025",
  //     activatedDate: "30 March, 2025",
  //   },
  //   {
  //     serialNumber: "SR35194658",
  //     status: "Assigned",
  //     vehicleClass: 5,
  //     vehicleIcon: "https://via.placeholder.com/40x20?text=VC5",
  //     assignedTo: "Rohit Singh",
  //     assignedDate: "30 March, 2025",
  //     activatedDate: "30 March, 2025",
  //   },
  //   {
  //     serialNumber: "SR35194658",
  //     status: "Unassigned",
  //     vehicleClass: 6,
  //     vehicleIcon: "https://via.placeholder.com/40x20?text=VC6",
  //     assignedTo: null,
  //     assignedDate: "-",
  //     activatedDate: "-",
  //   },
  //   {
  //     serialNumber: "SR35194658",
  //     status: "Unassigned",
  //     vehicleClass: 4,
  //     vehicleIcon: "https://via.placeholder.com/40x20?text=VC4",
  //     assignedTo: null,
  //     assignedDate: "-",
  //     activatedDate: "-",
  //   },
  //   {
  //     serialNumber: "SR35194658",
  //     status: "Unassigned",
  //     vehicleClass: 7,
  //     vehicleIcon: "https://via.placeholder.com/40x20?text=VC6",
  //     assignedTo: null,
  //     assignedDate: "-",
  //     activatedDate: "-",
  //   },
  // ];

  // Handle distributor summary API response
  useEffect(() => {
    if (checkDistributorSummary) {
      if (GetDistributorSummary?.status === 200 && GetDistributorSummary?.success) {
        const data = GetDistributorSummary?.data;

        const total = data?.totalFastag?.count || 0;
        const calculatePercentage = (count) => {
          if (!total) return 0;
          const percentage = (count / total) * 100;
          return percentage > 100 ? 100 : percentage;
        };

        // Update summary stats with API data
        const newSummaryStats = [
          {
            label: "Total FASTag",
            value: total,
            percent: 100,
            color: "#16a34a"
          },
          {
            label: "Dealer Assigned",
            value: data?.dealerAssigned?.count || 0,
            percent: calculatePercentage(data?.dealerAssigned?.count || 0),
            color: "#7c3aed"
          },
          {
            label: "Agent Assigned",
            value: data?.agentAssigned?.count || 0,
            percent: calculatePercentage(data?.agentAssigned?.count || 0),
            color: "#dc2626"
          },
          {
            label: "User Assigned",
            value: data?.userAssigned?.count || 0,
            percent: calculatePercentage(data?.userAssigned?.count || 0),
            color: "#f59e0b"
          },
          {
            label: "Available in Stock",
            value: data?.availableStock?.count || 0,
            percent: calculatePercentage(data?.availableStock?.count || 0),
            color: "#2563eb"
          },
        ];
        setSummaryStats(newSummaryStats);
      } else {
        // Enhanced error handling for summary API
        if (GetDistributorSummary?.status >= 400 && GetDistributorSummary?.status < 500) {
          // 4xx errors - show backend message
          ErrorToast(GetDistributorSummary?.message || 'Failed to fetch distributor summary');
        } else {
          ErrorToast(GetDistributorSummary?.message || 'Failed to fetch distributor summary');
        }
      }
      setCheckDistributorSummary(false);
    }
  }, [GetDistributorSummary]);

  const agentData = [
    { name: "Karishma", phone: "+91 9945*****82", status: "Active", assigned: 1000, activated: 500 },
    { name: "Anjali", phone: "+91 9945*****82", status: "Active", assigned: 0, activated: "-" },
    { name: "Supriya", phone: "+91 9945*****82", status: "Deactivate", assigned: "N/A", activated: "–" },
    { name: "Vikas", phone: "+91 9945*****82", status: "Active", assigned: 200, activated: 20 },
    { name: "Deepa", phone: "+91 9945*****82", status: "Deactivate", assigned: "N/A", activated: 15000 },
  ];

  const agentNames = [...new Set(agentData.map((agent) => agent.name))];

  const StatusBadge = ({ status }) => {
    const base = "px-2 py-[2px] rounded-full text-xs font-medium flex items-center gap-1 justify-self-start";
    if (status === "Assigned" || status === true) {
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Assigned</span>;
    } else {
      return <span className={`${base} bg-yellow-100 text-yellow-900`}><span className="h-2 w-2 bg-yellow-500 rounded-full" />Unassigned</span>;
    }
  };

  const isRowActivated = (item) => item?.isActivated === true || item?.userActivationStatus === 'Active';

  // Tag Ref ID cell: pricing info icon always; a "View Transactions" link that
  // opens the modal straight into the transactions view — only for activated tags.
  const renderTagRefCell = (item) => {
    const tagVal = item.tagRefId || item.serialNumber || '';
    const activated = isRowActivated(item);
    return (
      <div className="flex flex-col gap-0.5">
        <div className="flex items-center gap-2">
          <span>{tagVal}</span>
          {tagVal && (
            <button
              onClick={(e) => { e.stopPropagation(); setSelectedTagRefId(tagVal); setSelectedTagActivated(activated); setModalInitialTab('cost'); }}
              className="p-1 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-red-500 focus:outline-none"
              title="View pricing details"
            >
              <Info size={14} />
            </button>
          )}
        </div>
        {tagVal && activated && (
          <button
            onClick={(e) => { e.stopPropagation(); setSelectedTagRefId(tagVal); setSelectedTagActivated(true); setModalInitialTab('transactions'); }}
            className="text-xs font-medium text-blue-600 hover:underline text-left w-fit"
          >
            View Transactions
          </button>
        )}
      </div>
    );
  };

  // Shared sortable "FASTag Activation Date" column — one sort control for
  // whichever tab/role is currently showing it.
  const activationDateColumn = (label = "FASTag Activation Date") => ({
    label: (
      <div className="flex items-center gap-1">
        <span>{label}</span>
        <button
          onClick={(e) => { e.stopPropagation(); toggleActivationDateSort(); }}
          title="Sort by activation date"
          className="ml-0.5 text-[#EE3B31] hover:text-red-700 transition-colors focus:outline-none"
        >
          <ActivationDateSortIcon />
        </button>
      </div>
    ),
    key: "userActivationDate",
    render: (item) => <span className="whitespace-nowrap">{item.userActivationDate ? moment(item.userActivationDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'}</span>,
  });

  // Dealer's "User Status" column (Available Inventory tab) — Assigned/Available,
  // same wording and colors as Agent's own inventory page.
  const userStatusColumn = {
    label: "User Status",
    render: (item) => (item?.isActivated === true || item?.userActivationStatus === 'Active')
      ? <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900"><span className="h-2 w-2 bg-green-500 rounded-full" />Activated</span>
      : <span className="inline-flex items-center gap-1 whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-yellow-100 text-yellow-900"><span className="h-2 w-2 bg-yellow-500 rounded-full" />Available</span>,
  };

  // "View Details" — kept for Distributor; Dealer sees the activation date
  // column in its place instead.
  const actionColumn = {
    label: "Action",
    key: "assign",
    tdClassName: 'flex justify-end',
    render: (item) => (
      <div className='flex gap-3 items-center'>
        <button className="text-blue-600 text-sm font-medium hover:underline"
          onClick={() => { handleAgentClick(true, item); setModalItem(item) }}>
          View Details
        </button>
      </div>
    ),
  };

  const columnsAvailable = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    // Dealer has no separate "Dealer Inventory" tab, so this is their primary
    // stock view — User Status sits right after Tag Ref ID, same as Agent's page.
    ...(role === 'dealer' ? [userStatusColumn] : []),
    {
      label: "Batch Id",
      key: "batchId",
    },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px] h-auto"
            />
            <p className="text-sm text-gray-700">{vehicleClassData?.value || "N/A"}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? (
                <Eye className="h-5 w-5 text-gray-400" />
              ) : (
                <EyeOff className="h-5 w-5 text-gray-400" />
              )}
            </div>
          </div>
        );
      },
    },
    {
      label: "Assigned Date",
      key: "assignedDate",
      render: (item) => item.assignedDate ? moment(item.assignedDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'
    },
    // Dealer: the sortable activation date closes out the row instead of Action.
    ...(role === 'dealer' ? [activationDateColumn()] : [actionColumn]),
  ];

  const columnsAgent = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    {
      label: "Batch Id",
      key: "batchId",
    },
    {
      label: "Agent Status",
      render: (e, _) => <StatusBadge status={e.agentStatus === "Assigned"} />
    },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px] h-auto"
            />
            <p className="text-sm text-gray-700">{vehicleClassData?.value || "N/A"}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? (
                <Eye className="h-5 w-5 text-gray-400" />
              ) : (
                <EyeOff className="h-5 w-5 text-gray-400" />
              )}
            </div>
          </div>
        );
      },
    },
    {
      label: "Assigned To",
      render: (item) => (
        item?.agentAssignedTo?.username || `N/A`
      )
    },
    {
      label: "Assigned Date",
      key: "agentAssignedDate",
      render: (item) => item.agentAssignedDate ? moment(item.agentAssignedDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'
    },
    {
      label: "FASTag Activation Status",
      render: (item) => item?.isActivated
        ? <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900">Activated</span>
        : <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-gray-100 text-gray-700">Available</span>,
    },
    activationDateColumn(),
    // Dealer loses the Action column on this tab too — Distributor keeps it.
    ...(role === 'dealer' ? [] : [actionColumn]),
  ];

  // Dealer Inventory: FASTags this distributor has assigned down to their dealers.
  const columnsDealer = [
    {
      label: "Tag Ref ID",
      key: "tagRefId",
      render: (item) => renderTagRefCell(item),
    },
    {
      label: "Batch Id",
      key: "batchId",
    },
    {
      label: "Vehicle Class",
      key: "vehicleClass",
      render: (item, idx) => {
        const vehicleClassData = getVehicleClassData(item.vehicleClass);
        return (
          <div className="flex gap-2 items-center">
            <img
              src={vehicleClassData?.tagimage}
              alt="Tag"
              className="w-[34px] h-auto"
            />
            <p className="text-sm text-gray-700">{vehicleClassData?.value || "N/A"}</p>
            <div
              className="pl-2 flex items-center cursor-pointer"
              onClick={() => toggleVisibility(idx, item)}
            >
              {visibleRows[idx] ? (
                <Eye className="h-5 w-5 text-gray-400" />
              ) : (
                <EyeOff className="h-5 w-5 text-gray-400" />
              )}
            </div>
          </div>
        );
      },
    },
    {
      label: "Dealer Name",
      render: (item) => item?.assignedTo?.username || 'N/A'
    },
    {
      label: "Assigned Date",
      key: "assignedDate",
      render: (item) => item.assignedDate ? moment(item.assignedDate).format('DD MMMM, YYYY, hh:mm A') : 'N/A'
    },
    {
      label: "Agent Status",
      render: (e) => <StatusBadge status={e.agentStatus === "Assigned"} />
    },
    {
      label: "FASTag Activation Status",
      render: (item) => item?.isActivated
        ? <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-green-100 text-green-900">Activated</span>
        : <span className="inline-block whitespace-nowrap px-2 py-[2px] rounded-full text-xs font-medium bg-gray-100 text-gray-700">Available</span>,
    },
    activationDateColumn(),
    // Distributor-only tab (Dealer never sees it) — Action column stays.
    actionColumn,
  ];



  // const filteredInventory = inventoryData
  //   .filter(item => {
  //     const serialMatch = serialNumber === "" || item.serialNumber.toLowerCase().includes(serialNumber.toLowerCase());
  //     const agentMatch = selectedAgent === "" || item.assignedTo === selectedAgent;
  //     return serialMatch && agentMatch;
  //   })
  //   .sort((a, b) => {
  //     if (!sortConfig.key || !sortConfig.direction) return 0;
  //     const key = sortConfig.key;
  //     const direction = sortConfig.direction === "asc" ? 1 : -1;

  //     const valA = typeof a[key] === "number" ? a[key] : a[key]?.toString().toLowerCase();
  //     const valB = typeof b[key] === "number" ? b[key] : b[key]?.toString().toLowerCase();

  //     if (valA < valB) return -1 * direction;
  //     if (valA > valB) return 1 * direction;
  //     return 0;
  //   });

  const vehicleData = getVehicleClassData(selectedClass.vehicleClass);




  // Dedicated to the download button: the screen's other loading flags drive
  // the table overlay and a refetch, which a download must not trigger.
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      setCheckInventoryDistributor(true);

      const tabName = activeTab === 'available'
        ? 'available'
        : activeTab === 'dealerInventory'
          ? 'dealer'
          : 'agent';

      const params = {
        tab: tabName,
        status: activeTab === 'available' ? 'Unassigned' : activeTab === 'dealerInventory' ? '' : 'Assigned',
        search: serialNumber,
        agent: activeTab === 'agentInventory' ? selectedAgent : '',
        dealer: activeTab === 'agentInventory' ? selectedInvDealer : (activeTab === 'dealerInventory' ? dealerTabDealer : ''),
        userActivationStatus: activeTab === 'agentInventory' ? activationFilter : '',
        // Same guard as getData, so the downloaded file matches the rows on screen.
        isActivated: (activeTab === 'dealerInventory' || activeTab === 'available') ? dealerActivationFilter : '',
      };

      const blob = await API.DownloadTabWiseExcel(params);

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const tabLabel = tabName === 'available' ? 'Available' : tabName === 'dealer' ? 'Dealer' : 'Agent';
      link.download = `Inventory_${tabLabel}_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      SuccessToast("Excel file downloaded successfully");
    } catch (error) {
      console.error("Download error:", error);
      ErrorToast("Failed to download Excel file");
    } finally {
      setCheckInventoryDistributor(false);
      setIsDownloading(false);
    }
  };

  const handleTab = (tab) => {
    setCurrentPage(1);
    setActiveTab(tab);
    if (tab !== 'agentInventory') {
      setSelectedAgent("");
      setActivationFilter("");
      // Reset the Agent-tab dealer cascade.
      setSelectedInvDealer("");
      setInvDealerAgents(null);
    }
    if (tab !== 'dealerInventory') {
      setDealerTabDealer("");
    }
    // The activation-date sort is per-tab; start fresh on every tab switch.
    setActivationDateSortEnabled(false);
    setActivationDateSortOrder("desc");
  };

  // Agent Inventory cascade: choose a dealer -> load that dealer's agents.
  const handleInvDealerChange = (dealerId) => {
    setSelectedInvDealer(dealerId);
    setSelectedAgent(""); // reset agent
    setCurrentPage(1);
    if (dealerId) {
      API.GetAgentsNames({ dealerId })
        .then((res) => setInvDealerAgents(Array.isArray(res?.data) ? res.data : []))
        .catch(() => setInvDealerAgents([]));
    } else {
      setInvDealerAgents(null); // back to the distributor's own agents
    }
  };

  const LeftComponent = () => {
    return (
      <div className="flex justify-start items-center gap-2">
        <button
          onClick={() => handleTab('available')}
          className={`${activeTab === 'available'
            ? 'bg-red-500 text-white'
            : 'bg-[#FEF5F5] text-[#1F1715]'
            } text-[12px] font-medium px-4 py-2 rounded-full`}
        >
          Available Inventory
        </button>

        {role === 'distributor' && (
          <button
            onClick={() => handleTab('dealerInventory')}
            className={`${activeTab === 'dealerInventory'
              ? 'bg-red-500 text-white'
              : 'bg-[#FEF5F5] text-[#1F1715]'
              } text-[12px] font-medium px-4 py-2 rounded-full`}
          >
            Dealer Inventory
          </button>
        )}

        <button
          onClick={() => handleTab('agentInventory')}
          className={`${activeTab === 'agentInventory'
            ? 'bg-red-500 text-white'
            : 'bg-[#FEF5F5] text-[#1F1715]'
            } text-[12px] font-medium px-4 py-2 rounded-full`}
        >
          Agent Inventory
        </button>
      </div>
    );
  };

  return (
    <>
      <div className="w-full min-w-0 overflow-x-hidden">
        {/* Summary Cards */}
        <div className="bg-[#FFFFFF] my-[30px] shadow-md rounded-xl p-4">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold text-gray-800 mb-[16px] mt-[27.5px] f">Inventory Summary</h2>
            {/* <EllipsisVerticalIcon className="text-gray-500 hover:text-gray-700 text-2xl" /> */}
          </div>
          <div className={`grid grid-cols-1 sm:grid-cols-2 ${role === 'dealer' ? 'lg:grid-cols-4' : 'lg:grid-cols-5'} gap-4 mb-[21px]`}>
            {summaryStats
              .filter((item) => !(role === 'dealer' && item.label === 'Dealer Assigned'))
              .map((item, idx) => (
                <div key={idx} className="bg-white rounded-xl p-4 shadow-sm border flex items-center gap-4">
                  <div className="w-14 h-14">
                    <CircularProgressbar
                      value={item.percent}
                      text={`${item.percent % 1 === 0 ? item.percent : item.percent.toFixed(2)}%`}
                      styles={buildStyles({
                        pathColor: item.color,
                        textColor: "#000",
                        trailColor: "#e5e7eb",
                        textSize: "22px",
                      })}
                    />
                  </div>
                  <div>
                    <div className="text-lg font-semibold text-gray-900">
                      {item.value.toLocaleString()}
                    </div>
                    <div className="text-sm text-gray-500">{item.label}</div>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Filters */}
        <div className="flex flex-col md:flex-row md:justify-between md:items-center flex-wrap gap-4 mb-6">
          <div className="flex flex-col lg:flex-row flex-wrap items-center lg:items-center gap-4 flex-1 min-w-0">
            <div className="relative w-full md:w-60">
              <TextInput
                name="serialNumber"
                placeholder="TagRefId / VC Class"
                value={serialNumber}
                onChange={(e) => {
                  setSerialNumber(e.target.value);
                  setCurrentPage(1);
                }}
                inputClass="pl-5 pr-3 py-[12.5px] text-sm"
              />
              <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                <Search className="w-4 h-4" />
              </div>
            </div>

            {/* Dealer Inventory tab: filter by dealer name */}
            {activeTab === 'dealerInventory' && (
              <div className="w-60">
                <CustomSelectInput
                  name="dealerTabDealer"
                  value={dealerTabDealer}
                  onChange={(e) => { setDealerTabDealer(e.target.value); setCurrentPage(1); }}
                  options={[
                    { name: "All Dealers", value: "" },
                    ...invDealers.map((dealer) => ({ name: dealer.username, value: dealer._id }))
                  ]}
                  inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                />
              </div>
            )}

            {/* FASTag Activation status filter — the Dealer Inventory tab, and the
                Available Inventory tab for whichever role is signed in. */}
            {(activeTab === 'dealerInventory' || activeTab === 'available') && (
              <div className="w-48">
                <CustomSelectInput
                  name="dealerActivationFilter"
                  value={dealerActivationFilter}
                  onChange={(e) => { setDealerActivationFilter(e.target.value); setCurrentPage(1); }}
                  options={[
                    { name: "Select Status", value: "" },
                    { name: "Activated", value: "true" },
                    { name: "Available", value: "false" },
                  ]}
                  inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                />
              </div>
            )}

            {activeTab === 'agentInventory' && (
              <>
                <div className="w-60">
                  <CustomSelectInput
                    name="selectedInvDealer"
                    value={selectedInvDealer}
                    onChange={(e) => handleInvDealerChange(e.target.value)}
                    options={[
                      { name: "All Dealers", value: "" },
                      ...invDealers.map((dealer) => ({ name: dealer.username, value: dealer._id }))
                    ]}
                    inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                  />
                </div>
                <div className="w-48">
                  <CustomSelectInput
                    name="selectedAgent"
                    value={selectedAgent}
                    onChange={(e) => {
                      setSelectedAgent(e.target.value);
                      setCurrentPage(1);
                    }}
                    options={[
                      { name: "All Agents", value: "" },
                      ...(invDealerAgents !== null ? invDealerAgents : agentDataNames).map((agent) => ({ name: agent.username, value: agent._id }))
                    ]}
                    inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                  />
                </div>
                <div className="w-40">
                  <CustomSelectInput
                    name="ActivationStatus"
                    value={activationFilter}
                    onChange={(e) => {
                      setActivationFilter(e.target.value);
                      setCurrentPage(1);
                    }}
                    options={[
                      { name: "Select Status", value: "" },
                      { name: "Active", value: "Active" },
                      { name: "Inactive", value: "Inactive" },
                    ]}
                    inputClass="py-[12.5px] px-3 text-sm text-gray-500"
                  />
                </div>
              </>
            )}
          </div>

          <div className="flex gap-2 w-full  md:w-auto justify-center">
            {(role === 'distributor' || role === 'dealer') && (
              <button
                className="border border-red-600 text-red-600 hover:bg-red-50 py-[11px] rounded-full px-[24px] font-medium flex items-center justify-center transition-colors"
                onClick={() => setShowReverse(true)}
              >
                <span className="xl:text-[14px] text-[13px] font-[700]">Reverse Inventory</span>
              </button>
            )}
            <button
              className=" bg-green-500 hover:bg-green-600 text-white py-[11px] rounded-full px-[37px] font-medium flex items-center justify-center space-x-2 transition-colors"
              onClick={() => setShow(true)}

            >
              <span className="xl:text-[14px] text-[13px] font-[700]">Purchase FASTag</span>
              <ArrowRight className="!w-[16px] !h-[16px]" />
            </button>
          </div>
        </div>


        {/* Table */}
        <CommonTable
          columns={activeTab === 'available' ? columnsAvailable : activeTab === 'dealerInventory' ? columnsDealer : columnsAgent}
          data={inventoryData || []}
          emptyMessage="No inventory Found"
          leftComponent={<LeftComponent />}
          paginationClass="items-center justify-between"
          setCurrentPage={setCurrentPage}
          setItemsPerPage={setItemsPerPage}
          currentPage={currentPage}
          isPagination={true}
          itemsPerPage={itemsPerPage}
          tableData={GetInventoryDistributor?.data?.data}
          total={GetInventoryDistributor?.data?.pagination?.total}
          totalPages={Math.ceil(GetInventoryDistributor?.data?.pagination?.total / itemsPerPage)}
          loading={checkInventoryDistributor}
          hideDateAndDownload={false}
          onDownload={handleDownload}
          downloading={isDownloading}
        />
        {/* Modal for Desktop */}
        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
            <div className="relative bg-white rounded-[20px] shadow-lg w-full max-w-xl p-6">
              <div className="absolute top-4 right-4 gap-3 flex-row flex">
                <button
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedIndex !== null) {
                      toggleVisibility(selectedIndex, selectedClass);
                    }
                  }}
                  className="text-gray-600 hover:text-red-500"
                >
                  <X size={20} />
                </button>
              </div>
              <h2 className="text-xl font-semibold mb-[4px] text-center">
                {vehicleData?.value}
              </h2>
              <p className="mb-[30px] text-sm text-center">
                {vehicleData?.description}
              </p>
              <div className="relative w-full flex justify-center items-center py-8 px-4">
                <div className="relative bg-white p-8 rounded-2xl shadow-2xl border border-gray-200 max-w-2xl w-full">
                  {/* Decorative corner accents */}
                  <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-red-500 rounded-tl-2xl opacity-20"></div>
                  <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-red-500 rounded-br-2xl opacity-20"></div>

                  {/* Image container with classic frame */}
                  <div className="relative bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border-2 border-gray-300 shadow-inner">
                    <img
                      src={vehicleData?.cardWebp}
                      alt={vehicleData?.name}
                      className="w-full h-auto object-contain rounded-lg transition-transform duration-500 hover:scale-[1.12]"
                    />
                  </div>

                  {/* Elegant bottom accent */}
                  <div className="mt-6 flex justify-center">
                    <div className="h-1 w-24 bg-gradient-to-r from-transparent via-red-500 to-transparent rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <CommonTableModal
        open={isModalOpen}
        onClose={() => { setIsModalOpen(false); getData(); getSummaryData(); }}
        title={`${assigningAgent?.username} • Assigned: ${assigningAgent?.assigned || 0} • Activated: ${assigningAgent?.activated || 0} • Available: 500`} // 👈 dynamic title
        columns={columns}
        columns1={columns1}
        tableData={data}
        tableData1={data}
        agentName={assigningAgent?.name}
      />
      {show && <FastagPurchase onClose={() => { setShow(false); getData(); getSummaryData(); }} />}
      <ReverseInventoryModal
        open={showReverse}
        role={role}
        onClose={() => setShowReverse(false)}
        onSuccess={() => { getData(); getSummaryData(); }}
      />
      {
        agentModalOpen &&
        <AgentDetails title="Details" modalItem={modalItem} agent={selectedAgentClick} onBack={() => { setAgentModalOpen(false); getData() }} />
      }
      {selectedTagRefId && (
        <TagCostInfoModal
          tagRefId={selectedTagRefId}
          isActivated={selectedTagActivated}
          initialTab={modalInitialTab}
          onClose={() => { setSelectedTagRefId(null); setSelectedTagActivated(false); }}
        />
      )}
    </>
  );
};

export default InventoryPage;
